$dependencyManager.addDependencyCallback('plyr', () => {

  class VideoLoader {
    constructor() {
      this.players = {}; // Initialize players map
      console.log('VideoLoader initialized');
    }

    load(container, videoUrl, autoplay = false) {
      this.container = jQuery(container);
      this.videoUrl = videoUrl;
      this.autoplay = autoplay;

      // Prefer provider/id coming from PHP if available
      this.provider = this.container.data('video-provider') || null;
      this.videoId = this.container.data('video-id') || null;


      // Initialize the video player
      return this.initPlayer();
    }

    initPlayer() {
      this.container.empty();

      let videoElement;
      const uniqueId = 'plyr-' + Math.random().toString(36).substr(2, 9);

      if (this.provider === 'vimeo' && this.videoId) {
        videoElement = jQuery('<div>', {
          id: uniqueId,
          'data-plyr-provider': 'vimeo',
          'data-plyr-embed-id': this.videoId
        });

      } else if (this.provider === 'youtube' && this.videoId) {
        videoElement = jQuery('<div>', {
          id: uniqueId,
          'data-plyr-provider': 'youtube',
          'data-plyr-embed-id': this.videoId
        });

      } else {
        // Fall back to old auto-detection

        if (this.isVimeoUrl(this.videoUrl)) {
          videoElement = jQuery('<div>', {
            'id': uniqueId,
            'data-plyr-provider': 'vimeo',
            'data-plyr-embed-id': this.extractVimeoId(this.videoUrl)
          });
        } else if (this.isYoutubeUrl(this.videoUrl)) {
          videoElement = jQuery('<div>', {
            'id': uniqueId,
            'data-plyr-provider': 'youtube',
            'data-plyr-embed-id': this.extractYoutubeId(this.videoUrl)
          });
        } else if (this.isMp4Url(this.videoUrl)) {
          videoElement = jQuery('<video>', {
            'id': uniqueId,
            src: this.videoUrl,
            playsinline: true, // Important for iOS and inline playback
          });
        } else if (this.isHlsUrl(this.videoUrl)) {
          videoElement = jQuery('<video>', {
            'id': uniqueId,
            playsinline: true,
          });
        } else {
          console.error('Unsupported video URL:', this.videoUrl);
          return Promise.reject('Unsupported video URL');
        }

      }

      this.container.append(videoElement);

      return new Promise((resolve, reject) => {
        try {
          // Quality Mappings of Bunny CDN - https://dash.bunny.net/stream/.../encoding
          const qualityMapping = { '240': 0, '360': 1, '480': 2, '720': 3, '1080': 4, /*'1440': 5, '2160': 6*/ };

          const plyrIconUrl = (window.$madSettings && window.$madSettings.plyrIconUrl) || null;

          const player = new Plyr(videoElement[0], {
            iconUrl: plyrIconUrl,
            loadSprite: true,
            iconPrefix: 'plyr',
            muted: true,
            autoplay: true,
            loop: { active: true },
            settings: ['quality', 'speed'],
            storage: { enabled: false },
            playsinline: true,
            quality: {
              default: '720',
              options: Object.keys(qualityMapping).reverse(),
              forced: true,
              onChange: (newQuality) => {
                const hlsInstance = videoElement.data('hls');
                if (hlsInstance) {
                  hlsInstance.currentLevel = qualityMapping[newQuality];
                }
              }
            }
          });
          this.players[uniqueId] = player;

          player.on('ready', () => {
            // Replace Plyr's SVG icon with a dashicon to match the pre-play overlay button
            const overlaidBtn = this.container[0].querySelector('.plyr__control--overlaid');
            if (overlaidBtn) {
              const svg = overlaidBtn.querySelector('svg');
              if (svg) svg.remove();
              if (!overlaidBtn.querySelector('.dashicons')) {
                const icon = document.createElement('span');
                icon.className = 'dashicons dashicons-controls-play';
                overlaidBtn.insertBefore(icon, overlaidBtn.firstChild);
              }
            }

            if (this.isHlsUrl(this.videoUrl)) {
              this.initializeHlsPlayer(player, videoElement[0], resolve, reject);
            } else {
              if (this.autoplay) {
                player.play().catch(e => console.warn(`Autoplay was prevented for ${this.videoUrl}:`, e));
              }
              resolve(player);
            }
          });

          player.on('error', (event) => {
            console.error('Plyr Error:', event.detail.plyr.source, event);
            reject(event);
          });

        } catch (error) {
          console.error('Error initializing Plyr:', error);
          reject(error);
        }
      });
    }

    initializeHlsPlayer(player, videoElement, resolve, reject) {
      if (Hls.isSupported()) {
        const hls = new Hls({
          // Optimized HLS config
          startLevel: 2, // Start from level 2 (e.g., 720p)
          maxBufferLength: 30, // Increased buffer length
          maxMaxBufferLength: 60,
          maxBufferSize: 60 * 1000 * 1000, // 60MB
          maxBufferHole: 0.5,
          lowLatencyMode: false, // Disable if not strictly live, can improve stability
        });
        hls.loadSource(this.videoUrl);
        hls.attachMedia(videoElement);
        jQuery(videoElement).data('hls', hls);

        resolve(player);

        hls.on(Hls.Events.ERROR, (event, data) => {
          if (data.fatal) {
            console.error('HLS fatal error:', data.type, data.details);
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                hls.recoverMediaError();
                break;
              default:
                hls.destroy();
                break;
            }
            reject('HLS error: ' + data.details);
          } else {
            console.warn('HLS non-fatal error:', data.type, data.details);
          }
        });
      } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
        videoElement.src = this.videoUrl;
        resolve(player);
        videoElement.addEventListener('error', (e) => {
          console.error('Native HLS playback error:', e);
          reject('Native HLS playback error');
        });
      } else {
        console.error('HLS is not supported in this browser.');
        reject('HLS not supported');
      }
    }

    isVimeoUrl(url) {
      const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
      return vimeoRegex.test(url);
    }

    isMp4Url(url) {
      const mp4Regex = /\.mp4$/i;
      return mp4Regex.test(url);
    }

    isHlsUrl(url) {
      const hlsRegex = /\.m3u8$/i;
      return hlsRegex.test(url);
    }

    extractVimeoId(url) {
      const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
      const match = url.match(vimeoRegex);
      return match ? match[1] : null;
    }

    isYoutubeUrl(url) {
      if (!url) return false;
      const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
      return youtubeRegex.test(url);
    }

    extractYoutubeId(url) {
      if (!url) return null;
      const youtubeRegex =
        /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^\"&?\/\s]{11})/;
      const match = url.match(youtubeRegex);
      return match ? match[1] : null;
    }
  }

  // Expose the VideoLoader class globally
  window.VideoLoader = VideoLoader;

}, hasPriority = true);